import React from 'react';
import { Container } from 'reactstrap';
import { Header } from './Header';

export function Layout(props) {

    return (
        <div className={'mb-5 ' + (props.IsPreview ? 'preview' : '')} >
        <Header />
        <Container>
            {props.children}
        </Container>
        </div>
    );
}
